import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { RoleService } from 'src/app/_services/role.service';
import { TokenPartner } from 'src/app/_types/partner.type';
import { ProposalDetails } from 'src/app/_types/proposals.type';
import { getInsuranceTypeLabel } from 'src/app/enums/insurance-type.enum';
import { PartnerType } from 'src/app/enums/partner.enums';
import { getPeriodicityLabel } from 'src/app/enums/proposal.enums';
import { Roles } from 'src/app/enums/roles.enum';
import { getSignatureTypeLabel } from 'src/app/enums/signature-type.enum';
import { Globals } from 'src/app/globals';
import { LanguageCode } from 'src/app/helpers/nationalities';
import { AddProposalModalComponent } from 'src/app/shared/components/add-proposal-modal/add-proposal-modal.component';
import { UpdatePolicyModalComponent } from 'src/app/shared/components/update-policy-modal/update-policy-modal.component';
import { ProposalProductsDisplayerComponent } from 'src/app/shared/components/view-proposals/proposal-products-displayer/proposal-products-displayer.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';
import { ExpansionPanelComponent } from 'src/app/shared/ui-kit/expansion-panel/expansion-panel.component';
import { environment } from 'src/environments/environment';

import { TaskDetailsService } from '../../task-details.service';
import { PolicyAcceptationMessageComponent } from './policy-acceptation-message/policy-acceptation-message.component';

/** « Information du contrat »; its documents are `TaskPolicyDocumentsComponent`'s. */
@Component({
  selector: 'app-task-policy-info',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CardComponent,
    ExpansionPanelComponent,
    ProposalProductsDisplayerComponent,
    PolicyAcceptationMessageComponent,
    IconsModule,
    AddProposalModalComponent,
    UpdatePolicyModalComponent,
  ],
  templateUrl: './task-policy-info.component.html',
})
export class TaskPolicyInfoComponent implements OnInit, OnDestroy {
  DATE_FORMAT = environment.DATE_FORMAT;

  lngCode =
    (this.cookieService.get('selectedCountryCode') as LanguageCode) || 'fr';

  getInsuranceTypeLabel = getInsuranceTypeLabel;

  getPeriodicityLabel = getPeriodicityLabel;

  canEdit = false;

  private permissionSubscription?: Subscription;

  constructor(
    private readonly cookieService: CookieService,
    private readonly taskDetailsService: TaskDetailsService,
    private readonly roleService: RoleService,
    private readonly globals: Globals
  ) {
    this.canEdit =
      (this.globals.getUser() as TokenPartner).userType === PartnerType.PARTNER;
  }

  ngOnInit(): void {
    if (!this.canEdit) {
      this.permissionSubscription = this.roleService
        .hasWritePermission(Roles.PROPOSALS)
        .subscribe({
          next: (hasWritePermission) => {
            this.canEdit = hasWritePermission;
          },
        });
    }
  }

  ngOnDestroy(): void {
    this.permissionSubscription?.unsubscribe();
  }

  protected get proposal(): ProposalDetails | null {
    return this.taskDetailsService.state.policy;
  }

  getSignatureTypeLabel = getSignatureTypeLabel;

  refreshTaskDetails() {
    this.taskDetailsService.refreshTaskDetails();
  }
}
